window.syncDeposits = async function (cart) {

    // If cart is not passed, fetch the latest cart
    if (!cart) {
        cart = await fetch('/cart.js?ts=' + Date.now())
            .then(res => res.json());
    }


    const requiredDeposits = {};
    const existingDeposits = {};

    /*
     * Find beer products and existing deposits
     */
    cart.items.forEach(item => {

        // Existing deposit product
        if (item.sku && item.sku.startsWith("DEP")) {

            existingDeposits[String(item.variant_id)] = item;

            return;
        }

        // Deposit variant ID from line-item property
        const depositVariant = item.properties && item.properties['_deposit_variant'];
        //const depositVariant = '49811994673394';

        //console.log('Product:', item.title);
        //console.log('Qty:', item.quantity);
        //console.log('Deposit Variant:', depositVariant);

        if (!depositVariant) {
            return;
        }

        const depositId = String(depositVariant);

        requiredDeposits[depositId] =
            (requiredDeposits[depositId] || 0) + item.quantity;

    });

    console.log('Required Deposits:', requiredDeposits);
    console.log('Existing Deposits:', existingDeposits);


    /*
     * Update existing deposits
     */
    const updates = {};

    Object.keys(existingDeposits).forEach(depositVariantId => {

        const depositItem =
            existingDeposits[depositVariantId];

        const requiredQty =
            requiredDeposits[depositVariantId] || 0;

        if (depositItem.quantity !== requiredQty) {

            updates[depositItem.key] =
                requiredQty;

        }
        delete requiredDeposits[depositVariantId];

    });


    /*
     * Add missing deposits
     */
    const additions = [];

    Object.keys(requiredDeposits).forEach(depositVariantId => {

        const quantity =
            requiredDeposits[depositVariantId];

        if (quantity > 0) {

            additions.push({

                id: Number(depositVariantId),

                quantity: quantity

            });

        }

    });


    /*
     * Update existing deposit quantities
     */
    if (Object.keys(updates).length > 0) {

        const response = await fetch('/cart/update.js', {

            method: 'POST',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({
                updates: updates
            })

        });

        if (!response.ok) {
            console.error('Deposit update failed');
        }

    }


    /*
     * Add missing deposits
     */
    if (additions.length > 0) {

        console.log('Adding deposits:', additions);

        const response = await fetch('/cart/add.js', {

            method: 'POST',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({

                items: additions

            })

        });

        if (!response.ok) {

            console.error(
                'Deposit add failed:',
                await response.text()
            );

        }

    }


    /*
     * Refresh page if cart changed
     */
    if (
        Object.keys(updates).length > 0 ||
        additions.length > 0
    ) {

        window.location.reload();

    }

};


document.addEventListener("DOMContentLoaded",()=>{

syncDeposits();

});